<template>
	<div>
		<el-header style = "padding:0;height: auto;">
				  <el-row>
				    <el-col :span="24">
						<header-top></header-top>
					</el-col>
					<el-col :span="24">
						<header-body></header-body>
					</el-col>
					<el-col :span="24">
						<header-footer></header-footer>
					</el-col>
				  </el-row>
		</el-header>
		<nav-banner></nav-banner>
		<search-pannel></search-pannel>
		<search-result></search-result>
	</div>
</template>
 
<script>
	import headerTop from '../../components/header/headerTop.vue'
	import headerBody from '../../components/header/header-body.vue'
	import headerFooter from '../../components/header/header-footer.vue'
	import navBanner from '../../components/navBanner/navBanner.vue'
	import searchPannel from '../../components/searchPannel/searchPannel.vue'
	import searchResult from '../../components/searchResult/searchResult.vue'
	import {getInfo} from '../../api/login.js'
	import {getToken} from '../../utils/auth.js'
	export default{
		components:{
			headerTop,
			headerBody,
			headerFooter,
			navBanner,
			searchPannel,
			searchResult
		},
		created() {
			if(getToken()){
				getInfo().then(res=>{
					
					this.$store.dispatch("Login",res)
				})
			}
		}
		
		
	}
</script>

<style>
</style>
